import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import type { Movie } from "@/mocks/movies";

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  icon: string;
  movies: Movie[];
  moreLink?: string;
  emptyText?: string;
}

export default function MovieSection({
  title,
  subtitle,
  icon,
  movies,
  moreLink,
  emptyText = "暂无推荐内容",
}: MovieSectionProps) {
  return (
    <section className="mt-12">
      <div className="mb-5 flex items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-500">
            <i className={`${icon} text-xl`} />
          </span>
          <div>
            <h2 className="font-heading text-xl font-600 text-foreground-950 md:text-2xl">
              {title}
            </h2>
            {subtitle && <p className="mt-0.5 text-xs text-foreground-500">{subtitle}</p>}
          </div>
        </div>
        {moreLink && (
          <Link
            to={moreLink}
            className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-accent-500"
          >
            查看更多
            <i className="ri-arrow-right-s-line" />
          </Link>
        )}
      </div>

      {movies.length === 0 ? (
        <div className="flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-background-300/60 py-16 text-foreground-500">
          <i className="ri-inbox-line text-4xl" />
          <p className="text-sm">{emptyText}</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </section>
  );
}